<template>
    <el-dialog :title="mainDialog.title" :visible.sync="mainDialog.visible" width="50%">
      <div class="dialog-main">
        <div class="handle-box">
            <el-button type="primary" icon="el-icon-plus" class="handle-del mr10" @click="showEditAccount({source_id:source_id}, 'create')">账号</el-button>
            <el-input v-model="query.title" placeholder="渠道名称" clearable class="handle-input mr10"></el-input>
            <el-select v-model="query.city_id" clearable class="handle-select mr10 w7rem" placeholder="区域" @change="changeCity">
                <el-option v-for="(item, index) in region" :key="index" :label="item.title" :value="item.id"></el-option>
            </el-select>
            <el-button type="primary" icon="el-icon-search" @click="getTableData">搜索</el-button>
        </div>
        <el-table :data="tableData" ref="multipleTable" highlight-current-row v-loading="loading" border>
            <el-table-column prop="id" align="center" label="编号" width="80"></el-table-column>
            <el-table-column prop="title" label="账号"></el-table-column>
            <el-table-column prop="city" align="center" label="区域" width="120">
                <template slot-scope="scope">
                    <span>{{ dictionary.getRegionItem(scope.row.city_id, '无') }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="220">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="showEditAccount(scope.row, 'edit')">编辑</el-button>
                    <el-button type="danger" size="mini" @click="deleteAccount(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination">
            <el-pagination
                @size-change="changeLimit"
                @current-change="changePage"
                :current-page="pagination.page"
                :page-size="pagination.limit"
                :page-sizes="[10, 30, 50, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagination.total"
            ></el-pagination>
        </div>

        <edit-account ref="editAccount" :parent="_self"></edit-account>
      </div>
    </el-dialog>
</template>

<script>
// import { defineComponent } from '@vue/composition-api'
import dictionary from '@/utils/dictionary.js';
import EditAccount from './edit.vue';

export default {
    props: {
        parent: {}
    },
    components: {
        EditAccount
    },
    data() {
        let region = dictionary.getRegion();
        return {
            region: region,
            source_id: 0,
            city_id: '',
            loading: false,
            mainDialog: {
                title: '账号管理',
                visible: false
            },
            query: {
                id: '',
                title: '',
                city_id: ''
            },
            tableData: [],
            pagination: {
                page: 1,
                limit: 10,
                total: 0
            }
        };
    },
    beforeMount() {
        this.dictionary = dictionary;
    },
    methods: {
        // 区域
        changeCity(id){
           this.city_id = id;
        },
        // 编辑账号信息
        showAccount(row) {
            this.mainDialog.title = row.title + '账号管理';
            this.mainDialog.visible = true;
            this.source_id = row.id;
            this.getTableData();
        },
        getTableData() {
            this.loading = true;
            let url = '/api/dictionary.account/index';
            let query = {
                ...this.query
            };
            query['source_id'] = this.source_id;
            query['pagination'] = this.pagination;
            query['city_id'] = this.city_id;
            this.$post(url, query).then(res => {
                this.tableData = res.data.list;
                this.pagination = res.data.pagination;
                this.loading = false;
            });
        },
        showEditAccount(row, type) {
            if (this.$refs['editAccount']) {
                this.$refs['editAccount'].showDialog(row, type);
            } else {
                this.$nextTick(function() {
                    this.$refs['editAccount'].showDialog(row, type);
                });
            }
        },
        changeLimit(limit) {
            this.pagination.limit = limit;
            this.getTableData();
        },
        changePage(page) {
            this.pagination.page = page;
            this.getTableData();
        },
        delAccount(id){
           let url = '/api/dictionary.account/delete'
           let query ={
               id: id
           }
           this.$post(url, query).then(res => {
                this.getTableData();
            });
        },
        deleteAccount(id){
            this.$confirm('确定删除此账号么, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.delAccount(id);
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        }
    }
};
</script>
<style lang="less" scoped>
 .dialog-main{
    padding:20px;
    box-sizing: border-box;
 } 
</style>
